import { render, staticRenderFns } from "./LoginOtp.vue?vue&type=template&id=24b31bec&"
import script from "./LoginOtp.vue?vue&type=script&lang=js&"
export * from "./LoginOtp.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/newLogin.css?vue&type=style&index=1&lang=css&"
import style2 from "./LoginOtp.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports